// src/js/modules/contact-ajax.js
export default function initContactAjax() {
    document.querySelectorAll('form.contact-form').forEach(attachContactAjax);
}

function attachContactAjax(form) {
    if (!form || form.__bound) return;
    form.__bound = true;

    const formBox    = form.closest('.contact__form');
    const successBox = formBox?.querySelector('.form-success');

    // початковий стан (включно з BFCache поверненням)
    form.hidden = false;
    if (successBox) successBox.hidden = true;
    window.addEventListener('pageshow', (ev) => {
        if (ev.persisted) {
            form.hidden = false;
            if (successBox) successBox.hidden = true;
            clearFormErrors(form);
        }
    });

    // знімаємо помилку при вводі
    form.addEventListener('input', (e) => {
        const el = e.target;
        if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement)) return;
        clearFieldError(el);
    });

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        // ⬇️ КЛІЄНТСЬКА ВАЛІДАЦІЯ
        clearFormErrors(form);
        const isValid = validateForm(form);
        if (!isValid) {
            // фокус на перше невалідне
            const firstInvalid = form.querySelector('[aria-invalid="true"]');
            firstInvalid?.focus();
            return;
        }

        const url   = form.dataset.ajax;   // data-ajax з шаблону
        const nonce = form.dataset.nonce;  // data-nonce з шаблону
        const fd = new FormData(form);
        fd.append('action', 'send_contact_ajax');
        fd.append('nonce', nonce);

        const btn = form.querySelector('.contact-form__submit');
        btn?.setAttribute('disabled', 'disabled');

        try {
            const res  = await fetch(url, { method: 'POST', body: fd, credentials: 'same-origin' });
            const data = await res.json();

            if (data?.success) {
                showSuccess(formBox, successBox, { seconds: 5 });
                form.reset();
            } else {
                // СЕРВЕРНІ ПОМИЛКИ → в поля
                if (data?.data?.errors && typeof data.data.errors === 'object') {
                    for (const [name, message] of Object.entries(data.data.errors)) {
                        const input = form.querySelector(`[name="${CSS.escape(name)}"]`);
                        if (input) setFieldError(input, String(message || 'Invalid'));
                    }
                    const firstInvalid = form.querySelector('[aria-invalid="true"]');
                    firstInvalid?.focus();
                }
                // на всяк випадок лог
                console.warn('Contact error', data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            btn?.removeAttribute('disabled');
        }
    });
}

/* ===================== Validation helpers ===================== */

function validateForm(form) {
    let ok = true;

    const first = form.querySelector('[name="first_name"]');
    const last  = form.querySelector('[name="last_name"]');
    const email = form.querySelector('[name="email"]');

    if (first && !first.value.trim()) {
        setFieldError(first, 'Required');
        ok = false;
    }
    if (last && !last.value.trim()) {
        setFieldError(last, 'Required');
        ok = false;
    }
    if (email) {
        const val = email.value.trim();
        if (!val) {
            setFieldError(email, 'Required');
            ok = false;
        } else if (!isValidEmail(val)) {
            setFieldError(email, 'Invalid email');
            ok = false;
        }
    }

    return ok;
}

function isValidEmail(v) {
    // простий, але надійний патерн
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
}

function setFieldError(input, message = 'Invalid') {
    const field = input.closest('.field');
    if (!field) return;

    field.classList.add('is-error');
    input.setAttribute('aria-invalid', 'true');

    let hint = field.querySelector('.field__hint');
    if (!hint) {
        hint = document.createElement('div');
        hint.className = 'field__hint';
        field.appendChild(hint);
    }
    hint.textContent = message;
}

function clearFieldError(input) {
    const field = input.closest('.field');
    if (!field) return;

    field.classList.remove('is-error');
    input.removeAttribute('aria-invalid');

    const hint = field.querySelector('.field__hint');
    if (hint && !hint.dataset.static) {
        // якщо хінт створений нами — чистимо текст; статичні можна позначити data-static
        hint.textContent = '';
    }
}

function clearFormErrors(form) {
    form.querySelectorAll('.field.is-error').forEach((f) => f.classList.remove('is-error'));
    form.querySelectorAll('[aria-invalid="true"]').forEach((el) => el.removeAttribute('aria-invalid'));
    form.querySelectorAll('.field__hint').forEach((hint) => {
        if (!hint.dataset.static) hint.textContent = '';
    });
}

/* ===================== Success screen ===================== */

function showSuccess(formBox, successBox, { seconds = 5 } = {}) {
    if (!formBox || !successBox) return;

    const formEl = formBox.querySelector('.contact-form');
    const active = successBox.querySelector('.fs-bar__active');
    const bg     = successBox.querySelector('.fs-bar__bg, .fs-bar__bg, .fs-bar__bg'); // селектор залишився універсальний
    const count  = successBox.querySelector('.fs-count');

    // перемикаємо стан
    formEl.hidden     = true;
    successBox.hidden = false;

    const barWidthPx = (bg && bg.clientWidth) ? bg.clientWidth : 472; // як у макеті
    if (active) active.style.width = '0px';
    if (count)  count.textContent  = String(seconds);

    const t0  = performance.now();
    const dur = seconds * 1000;

    function tick(now) {
        const p = Math.min(1, (now - t0) / dur);
        if (active) active.style.width = Math.round(barWidthPx * p) + 'px';

        const left = Math.ceil(seconds - seconds * p);
        if (count) count.textContent = String(left);

        if (p < 1) {
            requestAnimationFrame(tick);
        } else {
            // повертаємо форму
            successBox.hidden = true;
            formEl.hidden     = false;
            if (active) active.style.width = '0px';
            if (count)  count.textContent  = String(seconds);
        }
    }
    requestAnimationFrame(tick);
}
